import React from 'react';
import classnames from 'classnames';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import ShopSlide1 from '../../assets/ShopSection/Trucker-hats-banner.jpg';
import ShopSlide3 from '../../assets/ShopSection/Trading-cards-2021-banner.jpg';
import ShopSlide2 from '../../assets/ShopSection/Tshirts-ISNP-banner.jpg';
import ShopSlide4 from '../../assets/ShopSection/NN-Mug-banner.jpg';
import ShopSlide5 from '../../assets/ShopSection/Store-2021-2022-bundle-banner3b-SFW.jpg';
import ShopSlide6 from '../../assets/ShopSection/Store-2022-cards-banner3a-SFW.jpg';
import ShopSlide7 from '../../assets/ShopSection/Store-calendar-banner-mobile.jpg';

import styles from './css/GuestShopSection.module.css';
import '@splidejs/splide/dist/css/splide.min.css';


const NAKED_NEWS_STORE_URL = 'https://shop.nakednews.com';

const STORE_DATA = [
  [{
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide7,
  },
  {
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide5,
  }],
  [{
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide5,
  },
  {
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide6,
  }],
  [{
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide1,
  }, {
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide2,
  }],
  [{
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide3,
  }, {
    url: NAKED_NEWS_STORE_URL,
    image: ShopSlide4,
  }]];

const FLATTENED_STORE_DATA = STORE_DATA.flat();

function GuestHomeShopSection({ isMembersPage }) {

  return (
    <div
      className={
        classnames(styles.guestHomeShopContainer,
          {
            [styles.center]: !isMembersPage,
            [styles.membersPage]: isMembersPage,
          })}
      style={{ minHeight: 320 }}
    >
      <Splide
        className={styles.desktop}
        options={{
          width: '100%',
          arrows: true,
          pagination: true,
        }}
      >
        {STORE_DATA.map((items) => (
          <SplideSlide key={items.map((item) => item.image).join('-')} className={styles.shopBannerSlide}>
            {items.map((item) => (
              <a key={item.image} href={item?.url} rel="noreferrer" target="_blank">
                <img
                  alt="Shop Banner"
                  className={classnames(styles.shopBannerImage, 'unblurred')}
                  loading="lazy"
                  src={item.image}
                />
              </a>))}
          </SplideSlide>))}

      </Splide>
      <Splide
        className={styles.mobile}

      >
        {FLATTENED_STORE_DATA.map((item) => (
          <SplideSlide key={item.image}>
            <a key={item.image} href={item?.url} rel="noreferrer" target="_blank">
              <img
                alt="Shop Banner"
                className={classnames(styles.shopBannerImage, 'unblurred')}
                loading="lazy"
                src={item.image}
              />
            </a>
          </SplideSlide>))}

      </Splide>
    </div>
  );
}

export default React.memo(GuestHomeShopSection);
